module.exports = "<div class=description> <dl class=\"dl-horizontal m-l-md\"> <dt ng-repeat-start=\"item in $ctrl.document.linkDocument\"><span>{{item.linkDocumentTypeName}}</span></dt> <dd ng-repeat-end> <span ng-if=item.linkDocumentNumber>№ {{item.linkDocumentNumber}}</span> <span ng-if=item.linkDocumentDate>от {{item.linkDocumentDate | date: 'dd.MM.yyyy'}}</span> </dd> </dl> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/components/document/document-link/documentLinkView.html
// module id = 63
// module chunks = 0